import React from 'react';

const SkeletonAppDisabled = () => {
    return (
        <main className="w-[100%] pt-[88px]">
            <header className="flex mobile:flex-col justify-between desktop:flex-row laptop:flex-row gap-2">
                <div className="flex mobile:items-center gap-10">
                    <div className="mt-[6px] animate-pulse bg-gray-200 h-10 w-[277px] rounded"></div>
                </div>
                <div className="flex mobile:flex-col laptop:flex-row desktop:flex-row  gap-4">
                    <div className="animate-pulse bg-gray-200 h-8 w-[280px] rounded"/>
                    <div className="animate-pulse bg-gray-200 h-8 w-28 rounded"/>
                </div>
            </header>

            <main className="w-[100%] pt-8">
                <section style={{ width: '100%'}}>
                    <div className="grid grid-rows-2 gap-4 laptop:grid-cols-[minmax(0,_1fr)_minmax(0,_2fr)] desktop:grid-cols-[minmax(0,_1fr)_minmax(0,_2fr)]">
                        <div className="grid grid-rows-3 gap-4 desktop:grid-cols-1 desktop:min-h-[78vh] tablet:max-h-[420px] laptop:min-h-[420px] desktop:max-h-[78vh] laptop:max-h-[420px]">
                            <div className="animate-pulse bg-gray-200 w-full rounded"/>
                            <div className="animate-pulse bg-gray-200 w-full rounded"/>
                            <div className="animate-pulse bg-gray-200 w-full rounded"/>
                        </div>
                        <div className="grid laptop:grid-cols-1 gap-4">
                            <div className="grid grid-rows-[minmax(0,_150px)_minmax(150px,_1fr)] gap-4">
                                <div className="animate-pulse bg-gray-200 w-full rounded desktop:min-h-[78vh] tablet:max-h-[420px] laptop:min-h-[40px] desktop:max-h-[80vh] laptop:max-h-[420px]"/>
                            </div>
                        </div>
                    </div> 
                    <div className="animate-pulse bg-gray-200 h-54 w-full rounded"/>    
                </section>
            </main>
        </main>
    );
};

export default SkeletonAppDisabled;
